import { render } from "./NewDonorRegistrationPage.vue?vue&type=template&id=7c0a920c"
import script from "./NewDonorRegistrationPage.vue?vue&type=script&lang=js"
export * from "./NewDonorRegistrationPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__